module.exports = __webpack_public_path__ + "images/ui/icon_ranking_leaf_silver_15a37a3525a529c37f1e0bbde51f5c66.svg";